"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCourseLists = void 0;
const _ = require("lodash");
const models_1 = require("../../models");
const generateCourseLists = (region_courses, preferred_courses, number_of_rounds) => {
    const course_list = {};
    if (!region_courses || region_courses?.length === 0)
        return course_list;
    const top_rated = preferred_courses?.find((c) => c.name === models_1.PreferredCourseType.TOP_RATED);
    const best_sellers = preferred_courses?.find((c) => c.name === models_1.PreferredCourseType.BEST_SELLERS);
    const best_value = preferred_courses?.find((c) => c.name === models_1.PreferredCourseType.BEST_VALUE);
    let top_rated_courses = top_rated
        ? region_courses
            ?.filter((c) => top_rated?.courses ? top_rated?.courses.includes(c.id) : false)
            .map((x) => x.id)
            .sort((a, b) => {
            if (!top_rated.courses)
                return 0;
            return top_rated.courses.indexOf(a) - top_rated.courses.indexOf(b);
        })
        : [];
    let best_seller_courses = best_sellers
        ? region_courses
            ?.filter((c) => best_sellers?.courses ? best_sellers.courses.includes(c.id) : false)
            .map((x) => x.id)
            .sort((a, b) => {
            if (!best_sellers.courses)
                return 0;
            return (best_sellers.courses.indexOf(a) - best_sellers.courses.indexOf(b));
        })
        : [];
    let best_value_courses = best_value
        ? region_courses
            ?.filter((c) => best_value.courses ? best_value.courses.includes(c.id) : false)
            .map((x) => x.id)
            .sort((a, b) => {
            if (!best_value.courses)
                return 0;
            return best_value.courses.indexOf(a) - best_value.courses.indexOf(b);
        })
        : [];
    function repeatItems(items, itemCount) {
        if (itemCount === 0 || items.length === 0)
            return [];
        // Calculate how many times the array should be repeated
        const repeatCount = Math.ceil(itemCount / items.length);
        // Use _.flatMap and _.times to repeat the array
        const repeatedItems = _.flatMap(_.times(repeatCount, () => items));
        // Slice the array to get the exact number of items
        return repeatedItems.slice(0, itemCount);
    }
    top_rated_courses = repeatItems(top_rated_courses, number_of_rounds);
    best_seller_courses = repeatItems(best_seller_courses, number_of_rounds);
    best_value_courses = repeatItems(best_value_courses, number_of_rounds);
    return {
        top_rated: top_rated_courses,
        best_sellers: best_seller_courses,
        best_value: best_value_courses,
    };
};
exports.generateCourseLists = generateCourseLists;
